import { useEffect, useState } from 'react'

export function useDevice() {
    const [device, setDevice] = useState('desktop')
    const [firstRender, setFirstRender] = useState(true)

    useEffect(() => {
        function changeDevice() {
            if (window.innerWidth <= 550) {
                setDevice('mobile')
            } else if (window.innerWidth <= 1350) {
                setDevice('tablet')
            } else {
                setDevice('desktop')
            }
        }
        window.addEventListener('resize', changeDevice)

        if (firstRender) {
            changeDevice()
            setFirstRender(false)
        }

        return () => window.removeEventListener('resize', changeDevice)
    }, [])

    return device
}
